import React from 'react';
import type { ThemeClasses } from '../../types/appShared';

interface BudgetStats {
    totalBudget: number;
    totalSpent: number;
}

interface BudgetItem {
    name: string;
    allocated: number;
    spent: number;
}

interface BudgetViewProps {
    theme: ThemeClasses;
    stats: BudgetStats;
    budgetData: BudgetItem[];
}

const BudgetView: React.FC<BudgetViewProps> = ({ theme, stats, budgetData }) => {
    return (
        <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className={`${theme.card} p-6 rounded-xl shadow-lg border ${theme.border}`}>
                    <h3 className="text-sm text-gray-500 mb-1">Total Budget</h3>
                    <p className="text-3xl font-bold text-blue-600">SAR {stats.totalBudget.toLocaleString()}</p>
                </div>
                <div className={`${theme.card} p-6 rounded-xl shadow-lg border ${theme.border}`}>
                    <h3 className="text-sm text-gray-500 mb-1">Total Spent</h3>
                    <p className="text-3xl font-bold text-red-500">SAR {stats.totalSpent.toLocaleString()}</p>
                </div>
                <div className={`${theme.card} p-6 rounded-xl shadow-lg border ${theme.border}`}>
                    <h3 className="text-sm text-gray-500 mb-1">Remaining</h3>
                    <p className="text-3xl font-bold text-green-600">SAR {(stats.totalBudget - stats.totalSpent).toLocaleString()}</p>
                </div>
            </div>

            <div className={`${theme.card} rounded-xl shadow-lg border ${theme.border} overflow-x-auto`}>
                <table className="w-full">
                    <thead className="bg-gray-100">
                        <tr>
                            <th className="px-4 py-3 text-left">Category</th>
                            <th className="px-4 py-3 text-right">Allocated</th>
                            <th className="px-4 py-3 text-right">Spent</th>
                            <th className="px-4 py-3 text-right">Remaining</th>
                            <th className="px-4 py-3 text-center">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {budgetData.map((item, i) => {
                            // ✅ كانت من غير حماية قسمة على صفر — أي بند allocated=0 كان بيطلع NaN/Infinity%
                            const pct = item.allocated ? (item.spent / item.allocated) * 100 : 0;
                            return (
                                <tr key={i} className="border-b hover:bg-gray-50">
                                    <td className="px-4 py-3 font-medium">{item.name}</td>
                                    <td className="px-4 py-3 text-right">SAR {item.allocated.toLocaleString()}</td>
                                    <td className="px-4 py-3 text-right text-red-600">SAR {item.spent.toLocaleString()}</td>
                                    <td className="px-4 py-3 text-right font-semibold text-green-600">
                                        SAR {(item.allocated - item.spent).toLocaleString()}
                                    </td>
                                    <td className="px-4 py-3 text-center">
                                        <span className={`px-3 py-1 rounded-full text-xs font-semibold ${pct >= 90 ? "bg-red-100 text-red-700" : pct >= 80 ? "bg-orange-100 text-orange-700" : "bg-green-100 text-green-700"
                                            }`}>
                                            {pct.toFixed(0)}%
                                        </span>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default BudgetView;
